import { render } from "./ButtonExport.vue?vue&type=template&id=fa1ba850&scoped=true"
import script from "./ButtonExport.vue?vue&type=script&lang=js"
export * from "./ButtonExport.vue?vue&type=script&lang=js"

import "./ButtonExport.vue?vue&type=style&index=0&id=fa1ba850&scoped=true&lang=css"

import exportComponent from "/home/u624473994/domains/backoffice.quickpay.pe/quickshop-admin-main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa1ba850"]])

export default __exports__